
















































import { listFactory } from '@/main/pages';
import { showAlert } from '@/main/utils/notifications';
import { objectToCamelCaseShallow } from '@/main/utils/stringHelper';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, validateDateFields, getCurrentLanguageId } from '@/main/utils/commonFunctions';


import { NAME, MAX_DAYS } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	data() {
		return {
			parameters: '',
			serviceDueDetails:
			{
				reminderTimeInHrs: Number,
				serviceDueStatusId: Number,
				isReminderSet: false,
				remarks: null,
				customerName: '',
				vin: null,
				id: 0,
				contactedBy: 0
			},
			reminderHrs: Number,
			serviceDueDialog: false,
			validateMessage: '',
			isValid: true,
			fromDate: 'ServiceDueDateOd',
			toDate: 'ServiceDueDateDo',
		};
	},
	computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.WorkshopIds);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.WorkshopIds);
		},
	},
	watch: {
		reminderHrs(value) {
			this.serviceDueDetails.reminderTimeInHrs = value;
			this.validateHours(value);
		},
	},
	methods: {
		// Frontend validation method is required here as reminderInHrs is introduced in data() and it is visible only if user edits a row
		changeReminderSatus() {
			if (this.serviceDueDetails.isReminderSet) {
				if (this.reminderHrs != null) {
					this.isValid = true;
				} else { this.isValid = false; }
			} else if (this.reminderHrs != null) {
				this.isValid = true;
			} else {
				this.isValid = true;
			}
		},
		validateHours(value: number) {
			if (value >= 1 && value <= 8) {
				this.isValid = true;
				this.validateMessage = '';
			} else if (this.serviceDueDetails.isReminderSet && value == null || value >= 8) {
				this.isValid = false;
				this.validateMessage = this.LocalizeChyboveHlasky('HourValidate');
			}
		},
		editClick(event: any) {
			this.serviceDueDialog = true;
			this.serviceDueDetails.customerName = event.data.CUSTOMER_NAME;
			this.serviceDueDetails.vin = event.data.KAROSERIE_NR;
			this.serviceDueDetails.id = event.data.ID;
			this.serviceDueDetails.serviceDueStatusId = event.data.SERVICE_DUE_STATUS_ID;
			this.serviceDueDetails.remarks = event.data.FOLLOWUP_REMARK;
			this.serviceDueDetails.contactedBy = event.data.PERSON_ID_MADE_CONTACT;
			if (event.data.REMINDER_TIME_IN_HRS != null) {
				this.reminderHrs = event.data.REMINDER_TIME_IN_HRS;
				this.serviceDueDetails.isReminderSet = true;
			} else {
				this.reminderHrs = event.data.REMINDER_TIME_IN_HRS;
				this.serviceDueDetails.isReminderSet = false;
			}
		},
		async saveData() {
			this.serviceDueDialog = false;
			// Required validation for contactedBy and serviceDueStatusId
			if (!this.serviceDueDetails.serviceDueStatusId) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ServiceStatusRequired'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: { type: 'error' },
				});
				this.serviceDueDialog = true;
				return;
			}
			if (!this.serviceDueDetails.contactedBy) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ContactedByRequired'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: { type: 'error' },
				});
				this.serviceDueDialog = true;
				return;
			}
			this.startLoading();

			const { data: saveReminderResp } = await apiProvider.saveDueRemider(objectToCamelCaseShallow(this.serviceDueDetails));
			if (saveReminderResp) {
				showAlert({
					message: this.LocalizeChyboveHlasky('SaveSuccess'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.refreshTable();
			}
			this.endLoading();
		},
		async refreshTable() {
			await this.tableData();
			(this.$refs.table as any).refreshLayout();
		},
		validateDateRange() {
			if (this.ServiceDueDateOd && this.ServiceDueDateDo) {
				const milisecondPerDay = 1000 * 60 * 60 * 24;
				const from = new Date(this.ServiceDueDateOd);
				const to = new Date(this.ServiceDueDateDo);
				const diffTime = to.getTime() - from.getTime();
				const diffDays = diffTime / milisecondPerDay;
				if (from > to) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('GREATER_DATE_VALIDATION') });
					return false;
				}
				if (diffDays > MAX_DAYS) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('CR_MAX_DAYS_VALIDATION').replace('<DAYS>', `${MAX_DAYS}`) });
					return false;
				}
				const utc1 = Date.UTC(from.getFullYear(), from.getMonth(), from.getDate());
				const utc2 = Date.UTC(to.getFullYear(), to.getMonth(), to.getDate());
				const dayDifference = Math.floor((utc2 - utc1) / milisecondPerDay);
				if (dayDifference > 89) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_90_DAY_DIFF') });
					this.ServiceDueDateOd = null;
					this.ServiceDueDateDo = null;
					return false;
				}
			} else {
				return false;
			}
			return true;
		},
		async filterClick() {
			if (!validateDateFields(this, this.fromDate, this.toDate)) {
				return;
			}
			if (!this.validateDateRange()) {
				return;
			}
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.WorkshopIds,
				(columnsSeq) => ({
					WorkshopIds: this.WorkshopIds,
					ServiceDueDateOd: this.ServiceDueDateOd,
					ServiceDueDateDo: this.ServiceDueDateDo,
					ColumnSequence: columnsSeq.join(','),
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
					InvestorCode: this.loggedUser.OrganizaceData.Text,
				}),
			);
		},
		GetParameters(WorkshopIds : any, ServiceDueDateOd : any, ServiceDueDateDo : any) {
			this.parameters = '';
			this.parameters = this.parameters.concat(`ServiceDueDateOd=${new Date(ServiceDueDateOd!).toISOString()}&ServiceDueDateDo=${new Date(ServiceDueDateDo).toISOString()}&InvestorCode=${this.loggedUser.OrganizaceData.Text}`);
			if (WorkshopIds.length > 0) {
				WorkshopIds.forEach((WorkshopId: any) => {
					this.parameters = this.parameters.concat(`&WorkshopIds=${WorkshopId}`);
				});
			}
			return this.parameters;
		},
		async exportFun() {
			try {
				if (this.filter.WorkshopIds == null || this.filter.WorkshopIds.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}

				this.startLoading();
				const urlParameters: string = this.GetParameters(this.filter.WorkshopIds, new Date(this.ServiceDueDateOd!).toISOString(), new Date(this.ServiceDueDateDo!).toISOString());
				const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);
				if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {
				await apiProvider.GetServiceDueDetailsReport(urlParameters, columnsSeq, getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId));
				}
			} catch (error) {
				showAlert({
					message: this.LocalizeChyboveHlasky('LocalMsg'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
			} finally {
				this.endLoading();
			}
		},
	},
});
